import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

/**
 * IcWalletComponent for rendering wallet icon with optional gradient.
 */
@Component({
  selector: 'ic-wallet',
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './ic-wallet.html',
})
export class IcWalletComponent {
  /** The starting color of the icon gradient. MUST be explicitly passed. */
  @Input() startColor: string | null = null;

  /** The ending color of the icon gradient. MUST be explicitly passed. */
  @Input() endColor: string | null = null;

  /** The opacity of the icon. Defaults to 1. */
  @Input() opacity = 1;

  /** The width of the icon. Defaults to 14. */
  @Input() width: number | string = 14;

  /** The height of the icon. Defaults to 14. */
  @Input() height: number | string = 14;

  /** Default color used when no gradient is provided. */
  defaultColor = '#B8C0C6';

  /** Unique ID for the SVG gradient to avoid collisions. */
  gradientId = `primaryGradient-${Math.random().toString(36).slice(2)}`;

  /** Checks if both startColor and endColor are provided and non-empty. */
  get hasGradient(): boolean {
    return (
      typeof this.startColor === 'string' &&
      typeof this.endColor === 'string' &&
      this.startColor.trim() !== '' &&
      this.endColor.trim() !== ''
    );
  }
}
